import {
    ADD_SIZE_ITEM,
    AUTOCOMPLITE_DATA,
    CALC_EMPTY_ERROR,
    CHANGE_SIZE_TYPE,
    CHOSE_TICKET,
    CITY_REPLACE_VALUES,
    CLOSE_REQUEST_POPUP,
    CLOSE_TICKET,
    ERROR_CARGO_NAME,
    ERROR_CARGO_TYPE,
    ERROR_CITY_FROM,
    ERROR_CITY_TO,
    ERROR_DEPARTURE_DATE,
    ERROR_OVERALL_VOLUME_PLACES,
    ERROR_OVERALL_VOLUME_VOLUME,
    ERROR_OVERALL_VOLUME_WEIGHT,
    ERROR_REQUEST_USER_EMAIL,
    ERROR_REQUEST_USER_PHONE,
    ERROR_SIZES,
    GEOLOCATION_DATA,
    HIDE_LOADER,
    REMOVE_SIZE_ITEM,
    REQUEST_ERROR,
    REQUEST_SUCCESS,
    REQUEST_SUCCESS_CLOSE,
    SELECT_CARGO_TYPE_TOGGLE,
    SET_ADV_ADRESS_FINISH_VALUE,
    SET_ADV_ADRESS_FINISH_VALUE_VALUE,
    SET_ADV_ADRESS_START_VALUE,
    SET_ADV_ADRESS_START_VALUE_VALUE,
    SET_ADV_EXPORT_VALUE,
    SET_ADV_IMPORT_VALUE,
    SET_ADV_RAZM_FINISH_VALUE,
    SET_ADV_RAZM_START_VALUE,
    SET_ADV_STRAH_VALUE,
    SET_ADV_STRAH_VALUE_VALUE,
    SET_ADV_TERMINAL_FINISH_VALUE,
    SET_ADV_TERMINAL_START_VALUE,
    SET_CARGO_NAME_VALUE,
    SET_CARGO_TYPE_VALUE,
    SET_CITY_FROM_VALUE,
    SET_CITY_TO_VALUE,
    SET_DEPARTURE_DATE_VALUE,
    SET_OVERALL_VOLUME_PLACES,
    SET_OVERALL_VOLUME_VOLUME,
    SET_OVERALL_VOLUME_WEIGHT,
    SET_SIZE_COUNTER_VALUE,
    SET_SIZE_HEIGHT_VALUE,
    SET_SIZE_LENGTH_VALUE,
    SET_SIZE_WEIGHT_VALUE,
    SET_SIZE_WIDTH_VALUE,
    SET_USER_EMAIL_VALUE,
    SET_USER_PHONE_VALUE,
    SHOW_LOADER,
    SHOW_REQUEST_POPUP,
    TICKETS_REQUEST,
    SET_MAILING,
    SET_PROCESSING,
} from "./types";
import Cookies from "js-cookie";

let now = new Date();
let time = now.getTime();
time += 3600 * 1000;
now.setTime(time);
let expires = now;

let dep_date = new Date();
dep_date.setDate(dep_date.getDate() + 1);

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    window.location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

let departure = findGetParameter("departure");
let destination = findGetParameter("destination");
let weight = findGetParameter("weight");

const initialState = {
    isMobile: window.innerWidth < 992 ? true : false,
    template: "template-2",
    commision: 0,
    departure_zone: "",
    destination_zone: "",
    autocomplite: {
        loaded: false,
        data: [],
    },
    geolocation: {
        loaded: Cookies.get("calc_city_from") !== undefined ? true : false,
        data: "",
    },
    sizeType:
        Cookies.get("size_type") !== undefined
            ? parseInt(Cookies.get("size_type"))
            : 1,
    avia: [],
    fields: {
        cityFrom: {
            value:
                departure !== null
                    ? departure
                    : Cookies.get("city_from") !== undefined
                    ? Cookies.get("city_from")
                    : "",
            autocomplite: [],
            error: false,
        },
        cityTo: {
            value:
                destination !== null
                    ? destination
                    : Cookies.get("city_to") !== undefined
                    ? Cookies.get("city_to")
                    : "",
            autocomplite: [],
            error: false,
        },
        departureDate: {
            value:
                Cookies.get("departure_date") !== undefined &&
                Cookies.get("departure_date") !== "null"
                    ? new Date(Cookies.get("departure_date"))
                    : dep_date,
            minDate: dep_date,
            error: false,
        },
        cargoType: {
            value:
                Cookies.get("cargo_type") !== undefined
                    ? Cookies.get("cargo_type")
                    : "",
            toggle: false,
            error: false,
        },
        overallVolume: {
            places: {
                value:
                    Cookies.get("overall_volume_places") !== undefined
                        ? Cookies.get("overall_volume_places")
                        : "",
                error: false,
            },
            weight: {
                value:
                    weight !== null
                        ? weight
                        : Cookies.get("overall_volume_weight") !== undefined
                        ? Cookies.get("overall_volume_weight")
                        : "",
                error: false,
            },
            volume: {
                value:
                    Cookies.get("overall_volume_volume") !== undefined
                        ? Cookies.get("overall_volume_volume")
                        : "",
                error: false,
            },
        },
        sizes:
            Cookies.get("sizes") !== undefined
                ? JSON.parse(Cookies.get("sizes"))
                : [
                      {
                          sizeLength: {
                              value: "",
                          },
                          sizeWidth: {
                              value: "",
                          },
                          sizeHeight: {
                              value: "",
                          },
                          sizeVolume: {
                              value: "",
                          },
                          sizeWeight: {
                              value: "",
                          },
                          sizeCounter: {
                              value: "1",
                          },
                      },
                  ],
        sizesError: false,
        sizesUpdate: false,
        cargoName: {
            value:
                Cookies.get("cargo_name") !== undefined
                    ? Cookies.get("cargo_name")
                    : "",
            error: false,
        },
    },
    tickets_loading: false,
    tickets_error: "",
    tickets_btn: 0,
    course: 0,
    export_price: 0,
    import_price: 0,
    totalVolume: 0,
    totalWeight: 0,
    strahProc: 0.1,
    tickets: {},
    popup: false,
    popupChange: false,
    advancedOptions: {
        export: false,
        import: false,
        strah: false,
        strahValue: 0,
        terminalStart: false,
        terminalFinish: false,
        razmStart: false,
        razmFinish: false,
        adressStart: false,
        adressStartValue: "",
        adressFinish: false,
        adressFinishValue: "",
        mailing: true,
        processing: true,
    },
    advancedOptionsChange: false,
    cargoName: "",
    requestPopup: false,
    requestPopupError: "",
    requestUserPhone: "",
    requestUserPhoneError: false,
    requestUserEmail: "",
    requestUserEmailError: false,
    requestSuccess: false,
    requestSuccessMessage: "",
    emptyError: false,
    is_auto1: 0,
    is_auto2: 0,
    sale_procent: 0,
    totalPaidWeight: null,
};

export const appReducer = (state = initialState, action) => {
    if (action.type === AUTOCOMPLITE_DATA) {
        return { ...state, autocomplite: action.payload };
    } else if (action.type === SHOW_LOADER) {
        return { ...state, tickets_loading: true };
    } else if (action.type === HIDE_LOADER) {
        return { ...state, tickets_loading: false };
    } else if (action.type === CHOSE_TICKET) {
        return {
            ...state,
            popup: action.payload,
            popupChange: !state.popupChange,
        };
    } else if (action.type === TICKETS_REQUEST) {
        return {
            ...state,
            tickets_error: action.payload.tickets_error,
            tickets_btn: action.payload.tickets_btn,
            course: action.payload.course,
            export_price: action.payload.export_price,
            import_price: action.payload.import_price,
            tickets: action.payload.tickets,
            totalVolume: action.payload.totalVolume,
            totalWeight: action.payload.totalWeight,
            strahProc: action.payload.strahProc,
            avia: action.payload.avia,
            commision: action.payload.commision,
            departure_zone: action.payload.departure_zone,
            destination_zone: action.payload.destination_zone,
            is_auto1: action.payload.is_auto1,
            is_auto2: action.payload.is_auto2,
            sale_procent: action.payload.sale_procent,
            totalPaidWeight: action.payload.totalPaidWeight,
            popup: false,
        };
    } else if (action.type === GEOLOCATION_DATA) {
        if (action.payload.city && action.payload.city.length > 0) {
            let cities = state.autocomplite.data;
            let searched = false;
            for (let i = 0; i < cities.length; i++) {
                if (
                    action.payload.city.toLowerCase() ===
                    cities[i].toLowerCase()
                ) {
                    searched = true;
                }
            }
            if (searched) {
                return {
                    ...state,
                    geolocation: {
                        loaded: true,
                        data: action.payload.city,
                    },
                    fields: {
                        ...state.fields,
                        cityFrom: {
                            ...state.fields.cityFrom,
                            value: action.payload.city,
                            autocomplite: [],
                            error: false,
                        },
                    },
                };
            }
        }
        return {
            ...state,
            geolocation: {
                loaded: true,
                data: "",
            },
        };
    } else if (action.type === SET_CITY_FROM_VALUE) {
        Cookies.set("city_from", action.payload.value, {
            expires: expires,
        });
        return {
            ...state,
            fields: {
                ...state.fields,
                cityFrom: {
                    ...state.fields.cityFrom,
                    value: action.payload.value,
                    autocomplite: action.payload.autocomplite,
                    error: false,
                },
            },
        };
    } else if (action.type === SET_CITY_TO_VALUE) {
        Cookies.set("city_to", action.payload.value, { expires: expires });
        return {
            ...state,
            fields: {
                ...state.fields,
                cityTo: {
                    ...state.fields.cityTo,
                    value: action.payload.value,
                    autocomplite: action.payload.autocomplite,
                    error: false,
                },
            },
        };
    } else if (action.type === CITY_REPLACE_VALUES) {
        Cookies.set("city_from", action.payload.val1, { expires: expires });
        Cookies.set("city_to", action.payload.val2, { expires: expires });
        return {
            ...state,
            fields: {
                ...state.fields,
                cityFrom: {
                    ...state.fields.cityFrom,
                    value: action.payload.val1,
                },
                cityTo: { ...state.fields.cityTo, value: action.payload.val2 },
            },
        };
    } else if (action.type === SET_DEPARTURE_DATE_VALUE) {
        Cookies.set("departure_date", action.payload, { expires: expires });
        return {
            ...state,
            fields: {
                ...state.fields,
                departureDate: {
                    ...state.fields.departureDate,
                    value: action.payload,
                    error: false,
                },
            },
        };
    } else if (action.type === SELECT_CARGO_TYPE_TOGGLE) {
        return {
            ...state,
            fields: {
                ...state.fields,
                cargoType: {
                    ...state.fields.cargoType,
                    toggle: action.payload,
                },
            },
        };
    } else if (action.type === SET_CARGO_TYPE_VALUE) {
        Cookies.set("cargo_type", action.payload, { expires: expires });
        return {
            ...state,
            fields: {
                ...state.fields,
                cargoType: {
                    ...state.fields.cargoType,
                    value: action.payload,
                    toggle: false,
                    error: false,
                },
            },
        };
    } else if (action.type === CHANGE_SIZE_TYPE) {
        Cookies.set("size_type", action.payload, { expires: expires });
        return {
            ...state,
            sizeType: action.payload,
        };
    } else if (action.type === SET_OVERALL_VOLUME_PLACES) {
        Cookies.set("overall_volume_places", action.payload, {
            expires: expires,
        });
        return {
            ...state,
            fields: {
                ...state.fields,
                overallVolume: {
                    ...state.fields.overallVolume,
                    places: {
                        ...state.fields.overallVolume.places,
                        value: action.payload,
                        error: false,
                    },
                },
            },
        };
    } else if (action.type === SET_OVERALL_VOLUME_WEIGHT) {
        Cookies.set("overall_volume_weight", action.payload, {
            expires: expires,
        });
        return {
            ...state,
            fields: {
                ...state.fields,
                overallVolume: {
                    ...state.fields.overallVolume,
                    weight: {
                        ...state.fields.overallVolume.weight,
                        value: action.payload,
                        error: false,
                    },
                },
            },
        };
    } else if (action.type === SET_OVERALL_VOLUME_VOLUME) {
        Cookies.set("overall_volume_volume", action.payload, {
            expires: expires,
        });
        return {
            ...state,
            fields: {
                ...state.fields,
                overallVolume: {
                    ...state.fields.overallVolume,
                    volume: {
                        ...state.fields.overallVolume.volume,
                        value: action.payload,
                        error: false,
                    },
                },
            },
        };
    } else if (action.type === SET_SIZE_LENGTH_VALUE) {
        let new_sizes = state.fields.sizes;
        new_sizes[action.payload.index].sizeLength.value = action.payload.value;
        Cookies.set("sizes", JSON.stringify(new_sizes), {
            expires: expires,
        });
        return {
            ...state,
            fields: {
                ...state.fields,
                sizes: new_sizes,
                sizesUpdate: !state.fields.sizesUpdate,
            },
        };
    } else if (action.type === SET_SIZE_WIDTH_VALUE) {
        let new_sizes = state.fields.sizes;
        new_sizes[action.payload.index].sizeWidth.value = action.payload.value;
        Cookies.set("sizes", JSON.stringify(new_sizes), {
            expires: expires,
        });
        return {
            ...state,
            fields: {
                ...state.fields,
                sizes: new_sizes,
                sizesUpdate: !state.fields.sizesUpdate,
            },
        };
    } else if (action.type === SET_SIZE_HEIGHT_VALUE) {
        let new_sizes = state.fields.sizes;
        new_sizes[action.payload.index].sizeHeight.value = action.payload.value;
        Cookies.set("sizes", JSON.stringify(new_sizes), {
            expires: expires,
        });
        return {
            ...state,
            fields: {
                ...state.fields,
                sizes: new_sizes,
                sizesUpdate: !state.fields.sizesUpdate,
            },
        };
    } else if (action.type === SET_SIZE_WEIGHT_VALUE) {
        let new_sizes = state.fields.sizes;
        new_sizes[action.payload.index].sizeWeight.value = action.payload.value;
        Cookies.set("sizes", JSON.stringify(new_sizes), {
            expires: expires,
        });
        return {
            ...state,
            fields: {
                ...state.fields,
                sizes: new_sizes,
                sizesUpdate: !state.fields.sizesUpdate,
            },
        };
    } else if (action.type === SET_SIZE_COUNTER_VALUE) {
        let new_sizes = state.fields.sizes;
        new_sizes[action.payload.index].sizeCounter.value =
            action.payload.value;
        Cookies.set("sizes", JSON.stringify(new_sizes), {
            expires: expires,
        });
        return {
            ...state,
            fields: {
                ...state.fields,
                sizes: new_sizes,
                sizesUpdate: !state.fields.sizesUpdate,
            },
        };
    } else if (action.type === ADD_SIZE_ITEM) {
        let new_sizes = state.fields.sizes;
        new_sizes.push(action.payload);
        Cookies.set("sizes", JSON.stringify(new_sizes), {
            expires: expires,
        });
        return {
            ...state,
            fields: {
                ...state.fields,
                sizes: new_sizes,
                sizesUpdate: !state.fields.sizesUpdate,
            },
        };
    } else if (action.type === REMOVE_SIZE_ITEM) {
        let new_sizes = state.fields.sizes;
        new_sizes.splice(action.payload, 1);
        Cookies.set("sizes", JSON.stringify(new_sizes), {
            expires: expires,
        });
        return {
            ...state,
            fields: {
                ...state.fields,
                sizes: new_sizes,
                sizesUpdate: !state.fields.sizesUpdate,
            },
        };
    } else if (action.type === CLOSE_TICKET) {
        return {
            ...state,
            popup: false,
            popupChange: !state.popupChange,
        };
    } else if (action.type === SET_ADV_EXPORT_VALUE) {
        let advancedOptions = state.advancedOptions;
        advancedOptions.export = action.payload;
        return {
            ...state,
            advancedOptions: advancedOptions,
            advancedOptionsChange: !state.advancedOptionsChange,
        };
    } else if (action.type === SET_ADV_IMPORT_VALUE) {
        let advancedOptions = state.advancedOptions;
        advancedOptions.import = action.payload;
        return {
            ...state,
            advancedOptions: advancedOptions,
            advancedOptionsChange: !state.advancedOptionsChange,
        };
    } else if (action.type === SET_ADV_STRAH_VALUE) {
        let advancedOptions = state.advancedOptions;
        advancedOptions.strah = action.payload;
        return {
            ...state,
            advancedOptions: advancedOptions,
            advancedOptionsChange: !state.advancedOptionsChange,
        };
    } else if (action.type === SET_ADV_TERMINAL_START_VALUE) {
        let advancedOptions = state.advancedOptions;
        advancedOptions.terminalStart = action.payload;
        return {
            ...state,
            advancedOptions: advancedOptions,
            advancedOptionsChange: !state.advancedOptionsChange,
        };
    } else if (action.type === SET_ADV_TERMINAL_FINISH_VALUE) {
        let advancedOptions = state.advancedOptions;
        advancedOptions.terminalFinish = action.payload;
        return {
            ...state,
            advancedOptions: advancedOptions,
            advancedOptionsChange: !state.advancedOptionsChange,
        };
    } else if (action.type === SET_ADV_RAZM_START_VALUE) {
        let advancedOptions = state.advancedOptions;
        advancedOptions.razmStart = action.payload;
        return {
            ...state,
            advancedOptions: advancedOptions,
            advancedOptionsChange: !state.advancedOptionsChange,
        };
    } else if (action.type === SET_ADV_RAZM_FINISH_VALUE) {
        let advancedOptions = state.advancedOptions;
        advancedOptions.razmFinish = action.payload;
        return {
            ...state,
            advancedOptions: advancedOptions,
            advancedOptionsChange: !state.advancedOptionsChange,
        };
    } else if (action.type === SET_ADV_ADRESS_START_VALUE) {
        let advancedOptions = state.advancedOptions;
        advancedOptions.adressStart = action.payload;
        return {
            ...state,
            advancedOptions: advancedOptions,
            advancedOptionsChange: !state.advancedOptionsChange,
        };
    } else if (action.type === SET_ADV_ADRESS_FINISH_VALUE) {
        let advancedOptions = state.advancedOptions;
        advancedOptions.adressFinish = action.payload;
        return {
            ...state,
            advancedOptions: advancedOptions,
            advancedOptionsChange: !state.advancedOptionsChange,
        };
    } else if (action.type === SET_ADV_STRAH_VALUE_VALUE) {
        let advancedOptions = state.advancedOptions;
        advancedOptions.strahValue = action.payload;
        return {
            ...state,
            advancedOptions: advancedOptions,
            advancedOptionsChange: !state.advancedOptionsChange,
        };
    } else if (action.type === SET_ADV_ADRESS_START_VALUE_VALUE) {
        let advancedOptions = state.advancedOptions;
        advancedOptions.adressStartValue = action.payload;
        return {
            ...state,
            advancedOptions: advancedOptions,
            advancedOptionsChange: !state.advancedOptionsChange,
        };
    } else if (action.type === SET_ADV_ADRESS_FINISH_VALUE_VALUE) {
        let advancedOptions = state.advancedOptions;
        advancedOptions.adressFinishValue = action.payload;
        return {
            ...state,
            advancedOptions: advancedOptions,
            advancedOptionsChange: !state.advancedOptionsChange,
        };
    } else if (action.type === SET_CARGO_NAME_VALUE) {
        Cookies.set("cargo_name", action.payload, { expires: expires });

        return {
        ...state,
        fields: {
            ...state.fields,
            cargoName: {
                ...state.fields.cargoName,
                value: action.payload,
                error: false,
            },
        },
    };
    } else if (action.type === SHOW_REQUEST_POPUP) {
        return {
            ...state,
            requestPopup: true,
        };
    } else if (action.type === CLOSE_REQUEST_POPUP) {
        return {
            ...state,
            requestPopup: false,
        };
    } else if (action.type === SET_USER_PHONE_VALUE) {
        return {
            ...state,
            requestUserPhone: action.payload,
            requestUserPhoneError: false,
        };
    } else if (action.type === SET_USER_EMAIL_VALUE) {
        return {
            ...state,
            requestUserEmail: action.payload,
            requestUserEmailError: false,
        };
    } else if (action.type === REQUEST_ERROR) {
        return {
            ...state,
            requestPopupError: action.payload,
        };
    } else if (action.type === REQUEST_SUCCESS) {
        return {
            ...state,
            requestPopup: false,
            requestPopupError: "",
            requestUserPhone: "",
            requestUserPhoneError: false,
            requestUserEmail: "",
            requestUserEmailError: false,
            requestSuccess: true,
            requestSuccessMessage: action.payload,
        };
    } else if (action.type === REQUEST_SUCCESS_CLOSE) {
        return {
            ...state,
            requestSuccess: false,
            requestSuccessMessage: "",
            popup: false,
            popupChange: !state.popupChange,
        };
    } else if (action.type === CALC_EMPTY_ERROR) {
        return {
            ...state,
            emptyError: true,
        };
    } else if (action.type === ERROR_CITY_FROM) {
        return {
            ...state,
            fields: {
                ...state.fields,
                cityFrom: {
                    ...state.fields.cityFrom,
                    error: true,
                },
            },
        };
    } else if (action.type === ERROR_CITY_TO) {
        return {
            ...state,
            fields: {
                ...state.fields,
                cityTo: {
                    ...state.fields.cityTo,
                    error: true,
                },
            },
        };
    } else if (action.type === ERROR_DEPARTURE_DATE) {
        return {
            ...state,
            fields: {
                ...state.fields,
                departureDate: {
                    ...state.fields.departureDate,
                    error: true,
                },
            },
        };
    } else if (action.type === ERROR_CARGO_TYPE) {
        return {
            ...state,
            fields: {
                ...state.fields,
                cargoType: {
                    ...state.fields.cargoType,
                    error: true,
                },
            },
        };
    } else if (action.type === ERROR_OVERALL_VOLUME_PLACES) {
        return {
            ...state,
            fields: {
                ...state.fields,
                overallVolume: {
                    ...state.fields.overallVolume,
                    places: {
                        ...state.fields.overallVolume.places,
                        error: true,
                    },
                },
            },
        };
    } else if (action.type === ERROR_OVERALL_VOLUME_WEIGHT) {
        return {
            ...state,
            fields: {
                ...state.fields,
                overallVolume: {
                    ...state.fields.overallVolume,
                    weight: {
                        ...state.fields.overallVolume.weight,
                        error: true,
                    },
                },
            },
        };
    } else if (action.type === ERROR_OVERALL_VOLUME_VOLUME) {
        return {
            ...state,
            fields: {
                ...state.fields,
                overallVolume: {
                    ...state.fields.overallVolume,
                    volume: {
                        ...state.fields.overallVolume.volume,
                        error: true,
                    },
                },
            },
        };
    } else if (action.type === ERROR_SIZES) {
        return {
            ...state,
            fields: {
                ...state.fields,
                sizesError: true,
            },
        };
    } else if (action.type === ERROR_CARGO_NAME) {
        return {
            ...state,
            fields: {
                ...state.fields,
                cargoName: {
                    ...state.fields.cargoName,
                    error: true,
                },
            },
        };
    } else if (action.type === ERROR_REQUEST_USER_EMAIL) {
        return {
            ...state,
            requestUserEmailError: true,
        };
    } else if (action.type === ERROR_REQUEST_USER_PHONE) {
        return {
            ...state,
            requestUserPhoneError: true,
        };
    } else if (action.type === SET_MAILING) {
        let advancedOptions = state.advancedOptions;
        advancedOptions.mailing = action.payload;
        return {
            ...state,
            advancedOptions: advancedOptions,
            advancedOptionsChange: !state.advancedOptionsChange,
        };
    } else if (action.type === SET_PROCESSING) {
        let advancedOptions = state.advancedOptions;
        advancedOptions.processing = action.payload;
        return {
            ...state,
            advancedOptions: advancedOptions,
            advancedOptionsChange: !state.advancedOptionsChange,
        };
    } else {
        return state;
    }
};
